import React from "react";
import { Dropdown, ButtonGroup, Button } from "react-bootstrap";
import { useTheme } from "../theme/ThemeProvider";

interface ThemeToggleProps {
  inline?: boolean; // When true, shows as inline buttons instead of dropdown
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ inline = false }) => {
  const { theme, setTheme } = useTheme();

  const getThemeIcon = (currentTheme: string) => {
    switch (currentTheme) {
      case "light":
        return "ti ti-sun";
      case "dark":
        return "ti ti-moon";
      default:
        return "ti ti-device-desktop";
    }
  };

  const getThemeLabel = (currentTheme: string) => {
    switch (currentTheme) {
      case "light":
        return "Light";
      case "dark":
        return "Dark";
      default:
        return "Auto";
    }
  };

  if (inline) {
    return (
      <ButtonGroup size="sm" className="w-100">
        <Button
          variant={theme === "light" ? "primary" : "outline-secondary"}
          onClick={() => setTheme("light")}
          className="d-flex align-items-center justify-content-center"
        >
          <i className="ti ti-sun me-1"></i>
          Light
        </Button>
        <Button
          variant={theme === "dark" ? "primary" : "outline-secondary"}
          onClick={() => setTheme("dark")}
          className="d-flex align-items-center justify-content-center"
        >
          <i className="ti ti-moon me-1"></i>
          Dark
        </Button>
        <Button
          variant={theme === "auto" ? "primary" : "outline-secondary"}
          onClick={() => setTheme("auto")}
          className="d-flex align-items-center justify-content-center"
        >
          <i className="ti ti-device-desktop me-1"></i>
          Auto
        </Button>
      </ButtonGroup>
    );
  }

  return (
    <Dropdown align="end" className="me-3">
      <Dropdown.Toggle
        variant="link"
        id="theme-dropdown"
        className="nav-link text-white text-decoration-none border-0 bg-transparent p-2"
        title={`Current theme: ${getThemeLabel(theme)}`}
      >
        <i className={getThemeIcon(theme)}></i>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Header>Theme</Dropdown.Header>
        <Dropdown.Item
          onClick={() => setTheme("light")}
          active={theme === "light"}
        >
          <i className="ti ti-sun me-2"></i>
          Light
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => setTheme("dark")}
          active={theme === "dark"}
        >
          <i className="ti ti-moon me-2"></i>
          Dark
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => setTheme("auto")}
          active={theme === "auto"}
        >
          <i className="ti ti-device-desktop me-2"></i>
          Auto
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
